export type P6FormData = {
    legal_basis: string;
    team: { name: string; role: string; allocation: string }[];
    milestones: {
        code: string;
        activity: string;
        responsible: string;
        start_date: string;
        end_date: string;
        status: "planned" | "in_progress" | "done";
        phase: "planning" | "execution" | "reporting";
    }[];
    resources: {
        auditor_hours: string;
        supervisor_hours: string;
        travel_notes: string;
    };
    planning_risks: { risk: string; probability: string; mitigation: string }[];
    executive_summary: string;
    document_status: "draft" | "approved";
};

export function defaultP6FormData(): P6FormData {
    return {
        legal_basis: "",
        team: [],
        milestones: [],
        resources: {
            auditor_hours: "",
            supervisor_hours: "",
            travel_notes: "",
        },
        planning_risks: [],
        executive_summary: "",
        document_status: "draft",
    };
}
